import { Action, Reducer } from "redux";
import { AppThunkAction } from ".";
import { Get } from "../api/apiUtils";
import { ApiCallModel } from "../models";
import { ProcessFlowConfig } from "../models/ProcessFlowConfig";
import { PersistentDataService } from "../services/PersistentDataService";

export interface ProcessFlowConfigState {
  processFlowConfigs: ApiCallModel<ProcessFlowConfig[]>;
  config: ProcessFlowConfig | undefined;
}

export const defaultState = {
  processFlowConfigs: { isError: false, isLoading: false, result: undefined },
  config: undefined
} as ProcessFlowConfigState;

export interface GetAllConfigsAction {
  type: "GET_PROCESS_FLOW_CONFIGS";
  payload: ApiCallModel<ProcessFlowConfig[]>;
}

export interface SetActiveConfigAction {
  type: "SET_ACTIVE_CONFIG";
  payload: ProcessFlowConfig | undefined;
}

type KnownAction = GetAllConfigsAction | SetActiveConfigAction;

export const actionCreators = {
  getAllConfigs:
    (cacheFirst: boolean = false): AppThunkAction<KnownAction> =>
    (dispatch, getState) => {
      const state = getState();

      if (state.processFlowConfigState.processFlowConfigs.result) return;

      dispatch({
        type: "GET_PROCESS_FLOW_CONFIGS",
        payload: {
          isLoading: true,
          isError: false,
          result: undefined
        }
      });

      Get(`api/configuration`, cacheFirst)
        .then(result => result.json())
        .then(result => {
          PersistentDataService.saveProcessFlowConfigurationsAsync(
            result as ProcessFlowConfig[]
          );
          dispatch({
            type: "GET_PROCESS_FLOW_CONFIGS",
            payload: {
              isLoading: false,
              isError: false,
              result: result as ProcessFlowConfig[]
            }
          });
        })
        .catch(reason =>
          dispatch({
            type: "GET_PROCESS_FLOW_CONFIGS",
            payload: {
              isLoading: false,
              isError: true,
              result: undefined
            }
          })
        );
    },
  setActiveConfig:
    (processConfigId: number, version: string): AppThunkAction<KnownAction> =>
    (dispatch, getState) => {
      var state = getState();

      if (
        state.processFlowConfigState &&
        state.processFlowConfigState.processFlowConfigs.result
      ) {
        var result =
          state.processFlowConfigState.processFlowConfigs.result.find(
            f => f.id === processConfigId && f.version === version
          );

        if (result) {
          dispatch({
            type: "SET_ACTIVE_CONFIG",
            payload: result
          });
        }
      }
    },
  deleteActiveConfig: () => ({ type: "SET_ACTIVE_CONFIG", payload: undefined })
};

export const reducers: Reducer<ProcessFlowConfigState> = (
  state: ProcessFlowConfigState | undefined,
  incomingAction: Action
): ProcessFlowConfigState => {
  if (state === undefined) {
    return defaultState;
  }

  const action = incomingAction as KnownAction;
  switch (action.type) {
    case "GET_PROCESS_FLOW_CONFIGS":
      return { ...state, processFlowConfigs: action.payload };
    case "SET_ACTIVE_CONFIG":
      return { ...state, config: action.payload };
    default:
      return state;
  }
};
